import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=5dec1aec&scoped=true"
import script from "./Location.vue?vue&type=script&lang=ts"
export * from "./Location.vue?vue&type=script&lang=ts"
import style0 from "./Location.vue?vue&type=style&index=0&id=5dec1aec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dec1aec",
  null
  
)

export default component.exports